import React, { useEffect, useMemo, useState } from "react";
import {
    AppBar, Toolbar, Typography, Box, Grid, Paper, TextField, Button,
    IconButton, InputAdornment, Divider, Radio, RadioGroup, FormControlLabel,
    Checkbox, FormGroup, MenuItem, Chip, Tooltip
} from "@material-ui/core";
import {
    AccountTree, Search,
    Description, Folder, FolderOpen, Assessment, Settings, BarChart, Receipt, ExpandMore,
    ChevronRight, Person,
} from "@material-ui/icons";
import { TreeView, TreeItem } from "@material-ui/lab";
import "./ChartAccounts.css";
import { insh, sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import axios from "axios";
import OmlatList from "../AccountsIndexes/account-index-omlats";
import toast, { Toaster } from "react-hot-toast";
import AccountTreeApp from "./AccountTreeApp";
import i18next from "i18next";

const blankAccount = () => ({
    Code: "",
    AName: "",
    Nature: 1,
    Type: 1,
    ParentCode: "",
    FinalAcc: 1,
    Total_Debts: 0,
    Total_Credits: 0,
    Account_Value: 0,
    Acc_branch: 1,
    is_center: 0,
    default_center: 0,
    acc_level: 4,
    acc_sale_purch: 0,
    Date: "",
    UserName: "",
    omlat: [],
});

const balanceTotals = {
    Code: "",
    Total_Debts: 0,
    Total_Credits: 0,
    balance: 0,
    status: "",
};

export default function AccountsTree({ omlat, prmis, Accounts }) {
    const [isSearch, setIsSearch] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [totals, setTotals] = useState(balanceTotals);
    const [allTotals, setAllTotals] = useState([]);

    const viewHandle = async () => {
        setIsSearch(true)
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = "accounts-index/getAll"
        } else {
            Urls = `accounts-index/getAll?db_name=${sto?.db_name}`
        }
        await axios
            .get(
                uri + Urls
            )
            .then((res) => {
                setAccounts(res.data);
            })
            .catch((err) => {
                setAccounts([]);
            });
    };
    useEffect(() => {
        if (!isSearch) {
            viewHandle();
        }
    }, [accounts, isSearch])
    const [selectedCode, setSelectedCode] = useState(0);
    const [submitting, setSubmitting] = useState(false);

    const [search, setSearch] = useState("");
    const [account, setAccount] = useState(() => ({ ...blankAccount() }));
    const [mode, setMode] = useState("new");
    const [expanded, setExpanded] = useState(["1", "2", "3", "4"]);

    const [showExtra, setShowExtra] = useState(true);
    const [showBalances, setShowBalances] = useState(true);

    const selected = accounts.find(x => Number(x.Code) === Number(selectedCode));
    const rootAccounts = useMemo(() => {
        const q = search.trim().toLowerCase();
        if (!q) return accounts;
        const matches = accounts.filter(a =>
            String(a.Code).includes(q) || String(a.AName || "").toLowerCase().includes(q)
        );
        const needed = new Set();
        matches.forEach(a => {
            needed.add(String(a.Code));
            let parent = accounts.find(x => Number(x.Code) === Number(a.ParentCode));
            while (parent) {
                needed.add(String(parent.Code));
                parent = accounts.find(x => Number(x.Code) === Number(parent.ParentCode));
            }
        });
        return accounts.filter(a => needed.has(String(a.Code)));
    }, [accounts, search]);

    const childrenOf = (code) => rootAccounts
        .filter(a => Number(a.ParentCode) === Number(code))
        .sort((a, b) => Number(a.Code) - Number(b.Code));

    const changeField = (field, value) => {
        setAccount(prev => ({ ...prev, [field]: value }));
    };

    const changeParent = (field, value) => {
        const parentChildren = accounts.filter(a => Number(a.ParentCode) === Number(value));
        const maxChild = parentChildren.reduce((max, a) => Math.max(max, Number(a.Code) || 0), 0);
        const suggested = maxChild ? maxChild + 1 : `${value}0001`;

        const type = (suggested?.toString()?.length > 3) ? 2 : 1;
        setAccount(prev => ({
            ...prev, [field]: value, Code: String(suggested), Type: type
        }));
    };
    const selectAccount = (item) => {
        setSelectedCode(item.Code);
        setAccount({ ...blankAccount(), ...item });
        setMode("edit");
    };

    const resetForm = () => {
        setAccount(blankAccount());
        setSelectedCode(null);
        setMode("new");
        setSubmitting(false);
        setTotals(balanceTotals);
    };

    const timer = React.useRef();
    const [success, setSuccess] = useState(insh.LoadAndSucc);

    const ButtonSuccess = (prop, timr, data) => {
        timer.current = window.setTimeout(() => {
            setSuccess({ ...success, [prop]: true });
            resetForm();
        }, 2000);
    };
    const handleSave = () => {

        if (!String(account.AName || "").trim()) {
            alert("يرجى إدخال اسم الحساب.");
            return;
        }
        if (!account.ParentCode && Number(account.Type) === 2) {
            alert("يرجى تحديد الحساب الأب للحساب الفرعي.");
            return;
        }

        if (!account.ParentCode && Number(account.Type) === 2) {
            alert("يرجى تحديد الحساب الأب للحساب الفرعي.");
            return;
        }

        const parent = selected || accounts.find(a => Number(a.Code) === Number(account.ParentCode));
        if (!parent) {
            alert("اختر الحساب الأب أولاً.");
            return;
        }
        if (["121", "122", "123", "261", "253"].includes(account.ParentCode)) {
            alert("You Cant  Update This Account From This Screen");
            return;
        }
        setSubmitting(true);
        mode === "new" ? axios
            .post(uri + "Accounts_Index", account)
            .then((res) => {
                setAccounts([...accounts, res?.data]);
                ButtonSuccess("save", 500, res?.data);
                toast.success('تم الإضافة')
            })
            .catch((res) => {
                ButtonSuccess("save", 1000, res?.data);
                toast.error('خطاء في عملية الإضافة');
            })
            :
            axios
                .put(uri + "Accounts_Index", account)
                .then((res) => {
                    let newData = accounts.filter(a => String(a.Code) !== String(account.Code));
                    setAccounts([...newData, res?.data]);
                    ButtonSuccess("update", 1000, res?.data);
                    toast.success('تم التعديل')
                })
                .catch((res) => {
                    ButtonSuccess("update", 1000, res?.data);
                    toast.error("لم يتم التعديل")
                });
    };

    const handleDelete = async () => {
        if (!account.Code) return;
        if (accounts.some(a => Number(a.ParentCode) === Number(account.Code))) {
            alert("لا يمكن حذف حساب يحتوي على حسابات فرعية.");
            return;
        }
        if (!window.confirm("هل تريد حذف الحساب المحدد من بيانات العرض؟")) return;

        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `Accounts_Index?id=${account.Code}`
        } else {
            Urls = `Accounts_Index?id=${account.Code}&&db_name=${sto?.db_name}`
        }
        if (["121", "122", "123", "261", "253"].includes(account.ParentCode)) {
            alert("You Cant  Update This Account From This Screen");
            return;
        }
        setSubmitting(true);
        await axios.delete(uri + Urls).then(res => {
            setAccounts(prev => prev.filter(a => String(a.Code) !== String(account.Code)));
            resetForm();
            setSubmitting(false);
            toast.success("The Account Deleted");
        }).catch(err => {
            ButtonSuccess("delete", false);
            toast.error("not delete ")
        })

    };

    const renderTree = (node) => {
        const kids = childrenOf(node.Code);
        const isFolder = kids.length > 0 || Number(node.Type) === 1;
        const label = (
            <Box className={`tree-label ${String(selectedCode) === String(node.Code) ? "tree-label-selected" : ""}`}>
                {isFolder ? (expanded.includes(String(node.Code)) ? <FolderOpen className="tree-folder" /> : <Folder className="tree-folder" />) : <Description className="tree-leaf" />}
                <span className="tree-code">{node.Code}</span>
                <span className="tree-name">{node.AName}</span>
            </Box>
        );
        return (
            <TreeItem key={String(node.Code)} nodeId={String(node.Code)} label={label}>
                {kids.map(renderTree)}
            </TreeItem>
        );
    };

    const roots = rootAccounts.filter(a => !a.ParentCode || !rootAccounts.some(p => Number(p.Code) === Number(a.ParentCode)));

    const stats = [
        { title: "إجمالي الحسابات", value: accounts.length, icon: <AccountTree />, cls: "stat-blue" },
        { title: "الحسابات الرئيسية", value: accounts.filter(a => Number(a.Type) === 1).length, icon: <Description />, cls: "stat-purple" },
        { title: "الحسابات الفرعية", value: accounts.filter(a => Number(a.Type) === 2).length, icon: <Receipt />, cls: "stat-green" },
        { title: "الحسابات النهائية", value: accounts.filter(a => Number(a.acc_level) >= 4 || Number(a.Type) === 2).length, icon: <Assessment />, cls: "stat-orange" }
    ];
    const onChange = (e, { name, value }) => {
        setAccount({ ...account, [name]: value })
    };

    const getBalances = async (found) => {
        if (Number(found.Type) === 1) {
            return;
        }
        const oldTotals = allTotals.find((obj) => obj.Code.toString() === found.Code.toString());
        if (oldTotals) {
            setTotals({
                ...totals,
                Code: oldTotals.Code,
                Total_Debts: parseFloat(oldTotals?.Total_Debts).toFixed(2),
                Total_Credits: parseFloat(oldTotals?.Total_Credits).toFixed(2),
                balance: oldTotals.balance,
                status: oldTotals.status,
            });
            return;
        }
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `AccountReports/rptABalanceSum?branch=${-1}&&costCenter=${-1}
            &&acc_code=${found.Code.toString()}`
        } else {
            Urls = `AccountReports/rptABalanceSum?branch=${-1}&&costCenter=${-1}
            &&acc_code=${found.Code.toString()}&&db_name=${sto?.db_name}`
        }
        await axios
            .get(
                uri + Urls
            )
            .then((res) => {
                if (res.data == null) {
                    const newTotals = {
                        ...totals,
                        Code: found.Code,
                        Total_Debts: 0,
                        Total_Credits: 0,
                        balance: 0,
                        status: "",
                    }
                    setTotals(newTotals);
                    setAllTotals([...allTotals, newTotals]);
                } else {
                    let i = {
                        dept: Number(res.data.end_Dept),
                        credit: Number(res.data.end_Credit),
                    };
                    let balance = i.dept > i.credit ? parseFloat(i.dept - i.credit).toFixed(2) : parseFloat(i.credit - i.dept).toFixed(2);
                    let status = i.dept > i.credit ? "مدين" : "دائن";
                    const newTotals = {
                        ...totals,
                        Code: found.Code,
                        Total_Debts: parseFloat(i.dept).toFixed(2),
                        Total_Credits: parseFloat(i.credit).toFixed(2),
                        balance: balance,
                        status: status,
                    }
                    setTotals(newTotals);
                    setAllTotals([...allTotals, newTotals]);
                }
            })
            .catch((res) => {
                console.log("erro", res.error);
                setTotals(balanceTotals);
            });
    };
    return (
        <>
            <div className="coa-app" dir={i18next.language == "ar" ? "ltr" : "rtl"}>
                <AppBar position="static" elevation={0} className="coa-appbar">
                    <Toolbar className="coa-toolbar">

                        <Divider orientation="vertical" flexItem className="header-divider" />
                        <Box className="page-heading">
                            <Typography variant="h6">شجرة الحسابات</Typography>
                            <Typography variant="caption">إدارة الحسابات وتصنيفها ضمن الهيكل المحاسبي</Typography>
                        </Box>
                        <Box className="toolbar-spacer" />

                        <Box className="user-info">
                            <Typography variant="body2">{sto?.usernames}</Typography>
                            <Typography variant="caption">مدير النظام</Typography>
                        </Box>
                        <Person className="user-avatar" />
                    </Toolbar>
                </AppBar>

                <Box className="main-layout" style={{ paddingBottom: "3rem" }}>
                    <main className="workspace">
                        <Grid container spacing={2} className="stats-row">
                            {stats.map(s => (
                                <Grid item xs={6} md={3} key={s.title}>
                                    <Paper elevation={0} className={`stat-card ${s.cls}`}>
                                        <div className="stat-icon">{s.icon}</div>
                                        <div><Typography variant="body2">{s.title}</Typography><Typography variant="h6">{s.value}</Typography></div>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                        <Grid style={{ direction: i18next.language == "ar" ? "ltr" : "rtl" }}>
                            <Grid container spacing={2} className="content-row" >
                                <Grid item xs={12} lg={7} className="form-column" style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}>
                                    <Paper elevation={0} className="panel account-panel">
                                        <div className="panel-title">
                                            <div className="title-leading"><Description /><Typography variant="h6">بيانات الحساب</Typography></div>
                                            <Button variant="outlined" size="small" color="primary" onClick={resetForm}>جديد</Button>
                                        </div>

                                        <div className="form-content">
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <label className="field-label">رقم الحساب</label>
                                                    <TextField fullWidth variant="outlined" size="small" value={account.Code || ""} onChange={e => changeField("Code", e.target.value)} disabled={mode === "edit"} placeholder="رقم الحساب" />
                                                    <Typography className="helper-text">يتم توليده من الحساب الأب ويمكن تعديله عند الإضافة.</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <label className="field-label required">اسم الحساب</label>
                                                    <TextField fullWidth variant="outlined" size="small" value={account.AName || ""} onChange={e => changeField("AName", e.target.value)} placeholder="أدخل اسم الحساب" />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <label className="field-label">نوع الحساب</label>
                                                    <RadioGroup row value={String(account.Type || 1)} onChange={e => changeField("Type", Number(e.target.value))}>
                                                        <FormControlLabel value="1"
                                                            control={<Radio color="primary" />}
                                                            label="رئيسي"
                                                            disabled={(account?.Code?.toString()?.length > 3)}
                                                        />
                                                        <FormControlLabel value="2"
                                                            control={<Radio color="primary" />}
                                                            label="فرعي"
                                                            disabled={!(account?.Code?.toString()?.length > 3)}
                                                        />
                                                    </RadioGroup>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <label className="field-label">الحساب الأب</label>
                                                    <TextField
                                                        select fullWidth variant="outlined" size="small"
                                                        value={account.ParentCode == null ? "" : String(account.ParentCode)}
                                                        onChange={e => {
                                                            const p = accounts.find(a => String(a.Code) === String(e.target.value));
                                                            changeParent("ParentCode", e.target.value ? Number(e.target.value) : "");
                                                            if (p) changeField("Nature", p.Nature);
                                                        }}
                                                        disabled={mode === "edit"}
                                                        SelectProps={{ displayEmpty: true }}
                                                    >
                                                        <MenuItem value=""><em>بدون حساب أب</em></MenuItem>
                                                        {accounts.filter(a => Number(a.Type) === 1 || accounts.some(c => Number(c.ParentCode) === Number(a.Code))).map(a => (
                                                            <MenuItem key={a.Code} value={String(a.Code)}>{a.Code} - {a.AName}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                                {Number(account.Type) === 2 &&
                                                    <>
                                                        <Grid item xs={12} sm={6}>
                                                            <label className="field-label">طبيعة الحساب</label>
                                                            <RadioGroup row value={String(account.Nature || 1)} onChange={e => changeField("Nature", Number(e.target.value))}>
                                                                <FormControlLabel value="1" control={<Radio color="primary" />} label="مدين" />
                                                                <FormControlLabel value="2" control={<Radio color="primary" />} label="دائن" />
                                                            </RadioGroup>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <label className="field-label">التصنيف المالي (الدرجة)</label>
                                                            <TextField select fullWidth variant="outlined" size="small" value={String(account.FinalAcc == null ? 1 : account.FinalAcc)} onChange={e => changeField("FinalAcc", Number(e.target.value))}>
                                                                <MenuItem value="1">ميزانية / حسابات المركز المالي</MenuItem>
                                                                <MenuItem value="2">الأرباح والخسائر</MenuItem>
                                                            </TextField>
                                                        </Grid>
                                                    </>}
                                            </Grid>
                                            {Number(account.Type) === 2 &&
                                                <div className="section-box">
                                                    <div className="section-heading clickable" onClick={() => setShowExtra(v => !v)}>
                                                        <span>معلومات إضافية</span><Settings /> <span className="section-toggle">{showExtra ? "−" : "+"}</span>
                                                    </div>
                                                    {showExtra && <Grid container spacing={1}>
                                                        {/* <Grid item xs={12} sm={4}><div className="meta-field"><span>تاريخ الإنشاء</span><strong>{account.Date || "—"}</strong></div></Grid> */}
                                                        <Grid item xs={12} sm={4}><div className="meta-field">
                                                            <OmlatList
                                                                {...{

                                                                    onChange,
                                                                    object: account,
                                                                    formType: mode,
                                                                    omlat,
                                                                }}
                                                            />
                                                        </div></Grid>
                                                        <Grid item xs={12} sm={4}><div className="meta-field"><span>المستخدم</span><strong>{account.UserName || "مستخدم النظام"}</strong></div></Grid>
                                                        <Grid item xs={12} sm={4}><div className="meta-field"><span>مستوى الحساب</span><strong>{account.acc_level || "—"}</strong></div></Grid>
                                                    </Grid>}
                                                </div>
                                            }
                                            {Number(account.Type) === 2 && mode === "edit" &&
                                                <div className="section-box balances-section">
                                                    <div className="section-heading clickable" onClick={() => setShowBalances(v => !v)}>
                                                        <span>أرصدة الحساب</span><Assessment /><span className="section-toggle">{showBalances ? "−" : "+"}</span>
                                                    </div>
                                                    {showBalances && <Grid container spacing={1}>
                                                        <Grid item xs={12} sm={4}><div className="balance-card balance-blue"><span>رصيد الحساب</span><strong>{Number(totals.balance || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}{"  "}{totals?.status}</strong></div></Grid>
                                                        <Grid item xs={12} sm={4}><div className="balance-card balance-green"><span>إجمالي المدين</span><strong>{Number(totals.Total_Debts || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}</strong></div></Grid>
                                                        <Grid item xs={12} sm={4}><div className="balance-card balance-red"><span>إجمالي الدائن</span><strong>{Number(totals.Total_Credits || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}</strong></div></Grid>
                                                    </Grid>}
                                                </div>
                                            }
                                        </div>
                                    </Paper>
                                </Grid>

                                <Grid item xs={12} lg={5} className="tree-column" style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}>
                                    <Paper elevation={0} className="panel tree-panel">
                                        <div className="tree-panel-header">
                                            <div className="title-leading">
                                                <AccountTree onClick={() => setExpanded(["1", "2", "3", "4"])}/>
                                                <Typography variant="h6">دليل الحسابات</Typography></div>
                                        </div>
                                        <TextField
                                            fullWidth variant="outlined" size="small" className="tree-search"
                                            placeholder="ابحث في شجرة الحسابات..."
                                            value={search} onChange={e => setSearch(e.target.value)}
                                            InputProps={{ startAdornment: <InputAdornment position="start"><Search /></InputAdornment> }}
                                        />
                                        <div className="tree-scroll">
                                            <TreeView
                                                defaultCollapseIcon={<ExpandMore />}
                                                defaultExpandIcon={<ChevronRight />}
                                                expanded={expanded}
                                                onNodeToggle={(event, nodeIds) => setExpanded(nodeIds)}
                                                selected={selectedCode == null ? "" : String(selectedCode)}
                                                onNodeSelect={(event, nodeId) => {
                                                    const found = accounts.find(a => String(a.Code) === String(nodeId));
                                                    if (found) { selectAccount(found); }
                                                    if (found && found.Type == 2) getBalances(found);
                                                }}
                                            >
                                                {roots.sort((a, b) => Number(a.Code) - Number(b.Code)).map(renderTree)}
                                            </TreeView>
                                            {roots.length === 0 && <div className="empty-search">لا توجد حسابات مطابقة للبحث.</div>}
                                        </div>
                                        <div className="tree-footer">
                                            <Chip size="small" label={`${accounts.length} حساب`} />
                                            <Typography variant="caption">اختر حساباً لعرض بياناته</Typography>
                                        </div>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </main>
                </Box>
            </div>
            <AccountTreeApp {...{
                prmis,
                handleSave,
                handleDelete,
                submitting,
                resetForm,
                mode,
            }} />
            <Toaster
                position="top_center"
                reverseOrder={false}
                gutter={8}
                containerStyle={{
                    zIndex: 999999,
                }}
                toastOptions={{
                    duration: 3000,
                    style: {
                        fontFamily: "Arial",
                        fontSize: "15px",
                        fontWeight: "bold",
                        direction: "rtl",
                        zIndex: 999999
                    },
                }} />
        </>
    );
}
